export default __webpack_public_path__ + "static/media/question-bg.dea2368a.png";